import React,{ useEffect, useState } from 'react';
const AddEgg = ({ formValues, handleEggChange }) => {
  
  return (
    <div className="input-container">
        <label className="input-label">雞蛋</label>
        <input
            type="number"
            value={formValues.Egg ? formValues.Egg : 0}
            onChange={handleEggChange}
            onFocus={(e) => e.target.select()}
            className="input-field"
        />
    </div>

  );
};

export default AddEgg;
